<template>
  <div class="flex flex-col w-full gap-4">
    <!-- PROFILE TOP -->
    <div class="flex flex-col items-center gap-8">
      <div
        class="flex items-center overflow-hidden w-[7rem] h-[7rem]"
        :class="{'rounded-full': avatarRound, 'rounded-lg': !avatarRound}"
      >
        <img :src="img" :alt="name" class="w-full h-full" />
      </div>
      <div class="flex flex-col items-center w-full">
        <t-heading tag="h2" class="break-word w-full font-semibold text-center" color="black">{{ name }}</t-heading>
        <t-text v-if="title !== ''" size="xl" class="break-word w-full text-center" color="black">{{ title }}</t-text>
      </div>
    </div>
    <!-- PROFILE TOP -->

    <!-- PROFILE DESCRIPTION -->
    <t-text size="md" class="whitespace-pre-line" v-if="description !== ''" color="black">{{ description }}</t-text>
    <!-- PROFILE DESCRIPTION -->

    <!-- RELATED USERS -->
    <related-users
      v-if="related_users"
      :entity="related_users.entity"
      :title="related_users.title"
      :users="related_users.users"
      :expanded="related_users.expanded"
      class="w-full mt-4"
    />
    <!-- RELATED USERS -->
  </div>
</template>

<script>
  import RelatedUsers from '@/components/RelatedUsers.vue'
  export default {
    name: 't-profile-simple',
    props: {
      img: {
        type: String,
        required: true
      },
      avatarRound: {
        type: Boolean,
        default: true
      },
      name: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: false,
        default: ''
      },
      description: {
        type: String,
        required: false,
        default: ''
      },
      related_users: {
        type: Object
      }
    },
    components: {
      RelatedUsers
    }
  }
</script>
